import React, { useEffect, useState } from 'react';
import { Stack } from 'react-bootstrap';
import { ButtonData } from '../buttonGroup/ButtonGroup';
import MultiSelectButtonGroup from '../buttonGroup/MultiSelectButtonGroup';

export interface MultiFilterGroupProps {
  filterButtons: Array<ButtonData> | undefined;
  onFilterSelect: (filter: string) => void;
  activeScope?: string[];
}

export const MultiFilterGroup: React.FC<MultiFilterGroupProps> = ({
                                                                    filterButtons,
                                                                    onFilterSelect,
                                                                    activeScope = []
                                                                  }) => {
  const getActiveIndices = () => {
    if (!filterButtons) return [];

    return filterButtons.reduce((acc, fb, idx) => {
      if (fb.key && activeScope.includes(fb.key)) {
        acc.push(String(idx));
      }
      return acc;
    }, [] as Array<string>);
  };

  const [activeIndex, setActiveIndex] = useState<string[]>(getActiveIndices());

  useEffect(() => {
    setActiveIndex(getActiveIndices());
  }, [activeScope, filterButtons]);

  if (!filterButtons) {
    return <></>;
  }

  const handleButtonClick = (index: number) => {
    let indexStr = `${index}`;

    setActiveIndex((old) => {
      let copy = [...old];
      if (copy.includes(indexStr)) {
        copy.splice(copy.indexOf(indexStr), 1);
      } else {
        copy.push(indexStr);
      }
      return copy;
    });
    onFilterSelect(filterButtons[index].key ?? '');
  };

  return (
      <Stack
          direction="horizontal"
          gap={2}
          className="filters-container overflow-auto"
      >
        <MultiSelectButtonGroup
            buttons={filterButtons}
            activeIndex={activeIndex}
            onButtonClick={handleButtonClick}
        />
      </Stack>
  );
};